import { varAlpha } from 'minimal-shared/utils'
import { memo } from 'react'

import membershipBanner from 'assets/membership-banner.png'
import { formatToKM } from '../../util/number.helpers'
import { membershipLabel } from '../../util/staking/staking.helpers'
import ProfileStats from '../common/ProfileStats'
import { Image } from '../shared/image'

const MembershipProfile = ({
  t,
  userTier: {
    totalFiatValue,
    tier: { id, name }
  },
  stakedQBX
}) => {
  const level = membershipLabel({ t, id, name })
  return (
    <ProfileStats
      title={level}
      desc={t('membership.current-status')}
      stats={[
        { label: t('home.staked-balance'), value: formatToKM(stakedQBX) },
        {
          label: t('membership.value-staked'),
          value: `$${totalFiatValue && stakedQBX > 0 ? formatToKM(totalFiatValue) : 0}`
        }
      ]}
      statColumns={2}
      displayPic={{
        src: `/assets/tiers/${id}-t.png`
      }}
      banner={
        <Image
          src={membershipBanner}
          alt={level}
          ratio='16/6'
          slotProps={{
            overlay: {
              sx: (theme) => ({
                bgcolor: varAlpha(theme.vars.palette.common.blackChannel, 0.48)
              })
            }
          }}
        />
      }
    />
  )
}

export default memo(MembershipProfile)
